import History, {getQuery, getSearchString, defaultContext} from "@irati/utils/history/index"

const addQuery = (query) => {
  const location = {...History.location}
  const search = getQuery()
  location.search = getSearchString({...search, ...query})

  History.push(location, defaultContext, {scrollToTop: false})
}

export default addQuery
